import React from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  page: number;
  pageCount: number;
  baseUrl: string;
  queryParams?: string;
}

const Pagination: React.FC<IProps> = ({
  page,
  pageCount,
  baseUrl,
  queryParams,
}) => {
  const calculateLink = (pathname: string) => ({ search: queryParams, pathname });
  return (
    <div className="row mt-1">
      <div className="col-12 d-flex justify-content-center justify-content-md-end">
        <Link to={calculateLink(`${baseUrl}/0`)}>
          <div className="ml-0 escape pt-2">
            <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.379641 3.73V3.324L5.67164 0.09L6.20364 0.958L2.88564 2.988L1.61164 3.52L2.87164 3.968L6.27364 5.984L5.74164 6.824L0.379641 3.73ZM7.588 3.73V3.324L12.88 0.09L13.412 0.958L10.094 2.988L8.82 3.52L10.08 3.968L13.482 5.984L12.95 6.824L7.588 3.73Z" fill="#8294A6" />
            </svg>
          </div>
        </Link>
        {page > 0 && <Link to={calculateLink(`${baseUrl}/${page - 1}`)}>
          <div className="escape pt-2">
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.983821 3.73V3.324L6.27582 0.09L6.80782 0.958L3.48982 2.988L2.21582 3.52L3.47582 3.968L6.87782 5.984L6.34582 6.824L0.983821 3.73Z" fill="#8294A6" />
            </svg>
          </div>
        </Link>}
        {page > 0 && <Link to={calculateLink(`${baseUrl}/${page - 1}`)}><div  className="escape">{`${page}`}</div></Link>}
        <div  className="escape" style={{ border: '1px solid #FFD800' }}>{`${page + 1}`}</div>
        {pageCount > page + 1 && <Link to={calculateLink(`${baseUrl}/${page + 1}`)}><div  className="escape">{`${page + 2}`}</div></Link>}
        {pageCount > page + 1 &&  <Link to={calculateLink(`${baseUrl}/${page + 1}`)}>
          <div className="escape pt-2">
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.87782 3.184V3.59L1.58582 6.824L1.05382 5.97L4.37182 3.94L5.64582 3.408L4.38582 2.96L0.983821 0.944L1.51582 0.09L6.87782 3.184Z" fill="#8294A6" />
            </svg>
          </div>
        </Link>}
        <Link to={calculateLink(`${baseUrl}/${pageCount - 1}`)}>
          <div className="escape pt-2">
            <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.27364 3.184V3.59L0.981641 6.824L0.449641 5.97L3.76764 3.94L5.04164 3.408L3.78164 2.96L0.379641 0.944L0.911641 0.09L6.27364 3.184ZM13.482 3.184V3.59L8.19 6.824L7.658 5.97L10.976 3.94L12.25 3.408L10.99 2.96L7.588 0.944L8.12 0.09L13.482 3.184Z" fill="#8294A6" />
            </svg>
          </div>
        </Link>
      </div>
    </div>
  )
};

export default Pagination;
